import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import React, { useCallback, useMemo, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";
import SubGroup from "../SubGroup";

const today = new Date();
const todayValue = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function PlayerVolume() {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [name, setName] = useState("");
  const [idPlayer, setIdPlayer] = useState(0);

  const requestUser = useCallback(
    (currentPlayer) => {
      const url = `${process.env.REACT_APP_API2_URL}/Player/Player_GetInfo?Player=${currentPlayer}&IdUser=${userInfo.userId}`;
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setIdPlayer(data.idPlayer);
          setName(`${data.name} ${data.lastName} ${data.lastName2}`.trim());
        });
    },
    [userInfo]
  );

  const [startDate, setStartDate] = useState(todayValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(todayValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    [requestUser]
  );
  const onPlayerEnter = useCallback(
    (event) => {
      if (event.key === "Enter") {
        requestUser(player);
      }
    },
    [player, requestUser]
  );

  const [amountType, setAmountType] = useState(0);
  const onAmountTypeChange = useCallback(
    (event) => setAmountType(Number(event.target.value)),
    []
  );

  const { formatter: wagerTypesFormatter } = useDataFormatterHook({
    addEmpty: true,
    emptyText: "Grand Total",
    value: "wagerType",
    text: "description",
    path: `/Wager/WagerType_GetNameList`,
  });

  return (
    <div className="flex flex-col w-full gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onKeyDown={onPlayerEnter}
          onChange={onPlayerChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          disabled
          variant="outlined"
          label="Name"
          type="text"
          value={name}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <div className="col-span-2">
          <SubGroup>
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={amountType}
                onChange={onAmountTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Risk"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Win"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Default"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <fieldset disabled={!name} style={{ border: "none", padding: 0, margin: 0, opacity: name ? 1 : 0.5, pointerEvents: name ? "auto" : "none" }}>
        <Report
          title="Player Volume"
          getUrl={() => "/Addons/PlayerRisk_GetInfo"}
          getParams={() => ({
            IdPlayer: idPlayer,
            StartDate: startDate,
            EndDate: endDate,
            AmountType: amountType,
          })}
          getProcess={(data) =>
            data.map((item) => ({
              ...item,
              totalRisk: item.localRisk + item.onlineRisk,
            }))
          }
          getTotals={(data) => ({
            wagerType: "grand-total",
            description: "Grand Total",
            localRisk: data.reduce((acc, item) => acc + item.localRisk, 0),
            onlineRisk: data.reduce((acc, item) => acc + item.onlineRisk, 0),
            totalRisk: data.reduce((acc, item) => acc + item.totalRisk, 0),
          })}
        >
          <TableHeaderColumn
            dataSort
            dataField="wagerType"
            isKey
            hidden
            dataFormat={wagerTypesFormatter}
          >
            
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="description"
          >
            Wager Type
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="localRisk"
            dataFormat={decimalInvertedReportFormatter}
          >
            Local
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="onlineRisk"
            dataFormat={decimalInvertedReportFormatter}
          >
            Online
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="totalRisk"
            dataFormat={decimalInvertedReportFormatter}
          >
            Total
          </TableHeaderColumn>
        </Report>
      </fieldset>
    </div>
  );
}

export default PlayerVolume;
